export default __webpack_public_path__ + "static/media/1674.bbe859b5.png";